import errorView from "../views/errorView";
export function errorViewLogic(store, mainContent) {
    viewRendering(mainContent);
}
//view rendering
function viewRendering(mainContent) {
    mainContent.innerHTML = errorView();
}
